import React from 'react'
import { StyledTitle, StyledContent, StyledLogo} from './styled'
import { Row, Col, Container } from 'react-bootstrap'
const Content = (props) => {
    return (
            <Row className='pl-0 pl-lg-2 mt-4'>
                <Col
                    xl={{
                        span: 9,
                    }}
                    xs={12}
                >
                    <StyledTitle>{props.content.title}</StyledTitle>
                </Col>
                <Col
                    xl={3}
                    xs={4}
                    xs={5}
                    className='d-flex flex-column justify-content-center mb-3 mb-md-0'
                >
                    <StyledLogo className='ml-auto d-block' src={props.content.logo.url} alt={props.content.logo.url}/>
                </Col>
                <Col xs={12}>
                    <StyledContent dangerouslySetInnerHTML={{__html: props.content.description}} />
                </Col>
            </Row>
    )
}

export default Content